import React, { Component } from 'react';
import OrganizationInfo from './OrganizationInfo';
import ContactInfo from './ContactInfo';

class Information extends Component {
	constructor(props) {
    super(props)

    this.state = {
		formErrors: {contact_email: '', contact_name: '', contact_phone: '', name: '', address: '', vat_number: '', accounting_period: '', approved_at: ''},
		emailValid: false,
		nameValid: false,
		phoneValid: false,
		orgVatValid: false,
		orgNameValid: false,
		orgAddressValid: false,
		approvedateValid: false,
		accountingPeriodValid: false
		}
	this._onChange = this._onChange.bind(this);
  	}

  	_onChange(e) {
    	if(e===null) {
    		this.validateField("accounting_period", "")
    	} else {
    		if(e._d) {
    			this.validateField("accounting_period", e);
    		} else {
    			this.props.onChange(e);
		    	const name = e.target.name;
		    	const value = e.target.value;
		    	this.validateField(name, value);
    		}
    	}
  	}

  	isNumeric(n) {
	  return !isNaN(parseFloat(n)) && isFinite(n);
	}

  	validateField(fieldName, value) {
	    let fieldValidationErrors = this.state.formErrors;
	    let emailValid = this.state.emailValid;
	    let nameValid = this.state.nameValid;
	    let phoneValid = this.state.phoneValid;
	    let orgNameValid = this.state.orgNameValid;
	    let orgAddressValid = this.state.orgAddressValid;
	    let orgVatValid = this.state.orgVatValid;
	    let approvedateValid = this.state.approvedateValid;
	    let accountingPeriodValid = this.state.accountingPeriodValid;

	    switch(fieldName) {
	      case 'contact_email':
	        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
	        fieldValidationErrors.contact_email = emailValid ? '' : ' er ugyldig';
	        break;
	      case 'contact_name':
	        nameValid = value.length >= 1;
	        fieldValidationErrors.contact_name = nameValid ? '': ' er for kort';
	        break;
	      case 'contact_phone':
	        phoneValid = value.length >= 8;
	        fieldValidationErrors.contact_phone = phoneValid ? '': ' er for kort';
	        break;
	      case 'name':
	        orgNameValid = value.length >= 1;
	        fieldValidationErrors.name = orgNameValid ? '': ' er for kort';
	        break;
	      case 'address':
	        orgAddressValid = value.length >= 1;
	        fieldValidationErrors.address = orgAddressValid ? '': ' er for kort';
	        break;
	      case 'vat_number':
	        orgVatValid = (value.length === 8 && this.isNumeric(value)) || value.length < 1;
	        fieldValidationErrors.vat_number = orgVatValid ? '': ' skal være på 8 cifre';
	        break;
	      case 'approved_at':
	        approvedateValid = (value.length === 4 && this.isNumeric(value)) || value.length < 1;
	        fieldValidationErrors.approved_at = approvedateValid ? '': ' skal være på 4 cifre';
	        break;
	      case 'accounting_period':
	        accountingPeriodValid = typeof value === "object";
	        fieldValidationErrors.accounting_period = accountingPeriodValid ? '': ' skal udfyldes';
	        break;
	      default:
	        break;
	    }
	    this.setState({formErrors: fieldValidationErrors,
	      emailValid: emailValid,
	      nameValid: nameValid,
	      phoneValid: phoneValid,
	      orgNameValid: orgNameValid,
	      orgAddressValid: orgAddressValid,
	      orgVatValid: orgVatValid,
	      approvedateValid: approvedateValid,
	      accountingPeriodValid: accountingPeriodValid
	    });
	}

	componentDidUpdate(prevProps, prevState) {
		if(this.state !== prevState || this.props.type !== prevProps.type || this.props.parent_id !== prevProps.parent_id) {
			this.validateForm();
		}
	}

	validateForm() {
	  	if(this.props.user.type === 'admin') {
	    	this.props.onValidateForm(
	    			(this.state.orgNameValid && this.state.orgAddressValid && this.state.approvedateValid &&
	    					this.props.type==="community") ||
	    			(this.state.orgNameValid && this.state.orgAddressValid && this.state.approvedateValid &&
	    					this.props.type==="congregation"));
	  	} else {
	    	this.props.onValidateForm(this.state.emailValid && this.state.nameValid && this.state.phoneValid && this.state.accountingPeriodValid);
	  	}
	}

	componentDidMount() {
  		this.setState({
  			emailValid: this.props.organization.contact_email ? true : false,
  			nameValid: this.props.organization.contact_name ? true : false,
  			phoneValid: this.props.organization.contact_name ? true : false,
  			orgNameValid: this.props.organization.name ? true : false,
  			orgAddressValid: this.props.organization.address ? true : false,
  			orgVatValid: this.props.organization.vat_number ? true : false,
  			approvedateValid: (this.props.organization.approved_at.length===0 || this.props.organization.approved_at.length===4) ? true : false,
  			accountingPeriodValid: this.props.organization.accounting_period_begin ? true : false
  		}, this.validateForm());
  	}

	render() {
		return(
			<div className="flexbox">
 	        	<OrganizationInfo
 	        		organization={this.props.organization}
 	        		errors={this.state.formErrors}
 	        		user={this.props.user}
					onChangeAccountingDate={this.props.onChangeAccountingDate}
 	        		onChange={this._onChange} />
  				<ContactInfo
  					organization={this.props.organization}
  					errors={this.state.formErrors}
  					user={this.props.user}
  					onChange={this._onChange} />
  			</div>)
	}
}

export default Information;


// WEBPACK FOOTER //
// ./src/modules/admin/organization/sections/Information.js